module.exports = __webpack_public_path__ + "0041a54fcb12cb73fb5cd148f54ea84b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg72.jpeg
// module id = 86
// module chunks = 0